export class ThreatsIocModel {
    id;
    value;
    feedId;
    context;
}
//# sourceMappingURL=threats-ioc.js.map